import React, { useCallback } from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import { ColumnFlex, Flex } from '~/components/common/containers'
import { PrimaryInfo, SecondaryInfo } from '~/components/common/typography'
import { translate } from '~/core/translate'
import { getItemDetails } from '~/selectors/salesforce'

import SalesforceIcon from '../icon'
import { ItemContent } from './styled'

const Container = styled(Flex)`
  align-items: flex-start;
  background-color: ${({ theme }) => theme.backgroundSalesforce};
  border-radius: 3px;
  padding: 16px;
  img {
    margin-right: 16px;
  }
`

const Item = ({ className, recordId, onSelected }) => {
  const item = useSelector(getItemDetails(recordId))
  const handleClick = useCallback(() => {
    onSelected(recordId)
  }, [onSelected, recordId])

  return (
    <Container className={className} onClick={handleClick}>
      <SalesforceIcon type={item.type} />

      <ItemContent>
        <ColumnFlex>
          <PrimaryInfo>{item.name}</PrimaryInfo>
          <SecondaryInfo>{item.displayType}</SecondaryInfo>
        </ColumnFlex>

        {item.ownerName && (
          <ColumnFlex>
            <PrimaryInfo>{item.ownerName}</PrimaryInfo>
            <SecondaryInfo>{translate('owner')}</SecondaryInfo>
          </ColumnFlex>
        )}
      </ItemContent>
    </Container>
  )
}

export default Item
